import axios from 'axios';
const baseApiUrl = 'services/customerservice/api/tls/captcha';

export default class CaptchaService {
  public googleCaptcha(token: string): Promise<any> {
    return axios.post(`${baseApiUrl}?token=${token}`);
  }
}
